import { functions } from '../lib/firebase';
import { httpsCallable } from 'firebase/functions';

export interface GLSLabelResponse {
  success: boolean;
  parcelId?: number;
  parcelNumber?: number;
  labelUrl?: string;
  error?: string;
}

/**
 * GLS címke generálás
 */
export const generateGLSLabel = async (orderId: string): Promise<GLSLabelResponse> => {
  try {
    console.log('📦 generateGLSLabel hívás:', { orderId, type: typeof orderId });
    const generateLabel = httpsCallable(functions, 'generateGLSLabel');
    const payload = { orderId };
    console.log('📤 Küldött payload:', payload);
    const result = await generateLabel(payload);
    console.log('📥 Válasz:', result.data);
    
    return result.data as GLSLabelResponse;
  } catch (error: any) {
    console.error('❌ GLS címke generálási hiba:', error);
    console.error('Error details:', { message: error.message, code: error.code, details: error.details });
    return {
      success: false,
      error: error.message || 'Ismeretlen hiba történt'
    };
  }
};

/**
 * GLS címke törlése
 */
export const cancelGLSLabel = async (orderId: string, parcelId: number): Promise<{ success: boolean; error?: string }> => {
  try {
    const cancelLabel = httpsCallable(functions, 'cancelGLSLabel');
    const result = await cancelLabel({ orderId, parcelId });
    
    return result.data as { success: boolean };
  } catch (error: any) {
    console.error('GLS címke törlési hiba:', error);
    return {
      success: false,
      error: error.message || 'Ismeretlen hiba történt'
    };
  }
};
